import moment from "moment";
import React from "react";

export default function Footer({ color, text }) {
  color = color
    ? `${color.includes("#") ? `text-[${color}]` : `text-${color}`}`
    : "text-white";
  return (
    <p className={`text-center ${color.toString()} text-xs`}>
      {text ??
        `Dompet Kartini adalah sebuah sistem dibawah kepemilikan PT. Kartini Otomasi Indonesia ©2021-${moment().format(
          "YYYY"
        )}`}
    </p>
  );
}
